"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectExtendedResponseModelAccessLevel = void 0;
exports.ProjectExtendedResponseModelAccessLevel = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
